import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeIcon from '../../assets/images/close_1close.png';
import { IBLSpinLoader } from '../../../IBLSpinLoader';
import { inviteUserByEmail, isEmailValid } from '../../helpers/utils';
import InvitedUsers from './InvitedUsers';

const InviteUser = ({ setFocused = () => {} }) => {
  const { t } = useTranslation('library');
  const [userEmail, setUserEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [notification, setNotification] = useState(null);
  const [invitedUsersModalFocused, setInvitedUsersModalFocused] =
    useState(false);

  const handleNotification = (notifData, autoClose = 5000) => {
    setNotification(notifData);
    setTimeout(() => {
      setNotification({});
    }, autoClose);
  };

  const handleInviteSuccessCallback = (data) => {
    setSubmitting(false);
    setUserEmail('');
    if (!!data?.email) {
      handleNotification({
        success: true,
        message: t('Invite sent to {email}', { email: data?.email }),
      });
    }

    //TODO notifications
  };

  const handleInviteErrorCallback = () => {
    setSubmitting(false);
    handleNotification({
      error: true,
      message: t('An error occurred. Please try again!'),
    });
  };

  const handleSendInvite = () => {
    if (isEmailValid(userEmail)) {
      handleNotification({});
      setSubmitting(true);
      inviteUserByEmail(
        userEmail,
        handleInviteSuccessCallback,
        handleInviteErrorCallback
      );
    } else {
      handleNotification({
        error: true,
        message: t('The email address is invalid.'),
      });
    }
  };

  return (
    <div
      style={{ display: 'flex' }}
      className="modal users-settings-invite-modal"
    >
      <div className="w-layout-vflex modal-container create-secret-key-modal-container">
        <div className="w-layout-hflex modal-header-2 space-between">
          <h3 className="modal-header-title-2">{t('Invite New User')}</h3>
          <div
            onClick={setFocused}
            prop-events-value-onclick="handleModalCloseClick"
            prop-events-names="onClick"
            data-w-id="a1034082-03aa-0166-ccd8-3d3e7afe115f"
            className="modal-close-wrapper-2"
          >
            <img src={closeIcon} loading="lazy" alt="" />
          </div>
          <div
            onClick={() => setInvitedUsersModalFocused(true)}
            data-w-id="a1034082-03aa-0166-ccd8-3d3e7afe1161"
            className="featured-mentor-see-all-btn"
          >
            {t('See All')}
          </div>
        </div>
        <div className="w-layout-vflex modal-body-2 create-secret-key-modal-body">
          <div className="secret-key-form-block w-form">
            <form
              id="email-form-2"
              name="email-form-2"
              data-name="Email Form 2"
              method="get"
              className="manage-account-form-2 secret-key-form"
              data-wf-page-id="65aec9c9e13ed74d8bfffe77"
              data-wf-element-id="a1034082-03aa-0166-ccd8-3d3e7afe1165"
            >
              <div className="w-layout-vflex input-block invite-user-secret-block">
                {!!notification?.message && (
                  <div
                    style={{
                      position: 'relative',
                      marginBottom: '10px',
                      top: 'unset',
                    }}
                    className={`pwd-notification-container`}
                  >
                    <div
                      className={`pwd-notification-text ${
                        notification?.success ? 'success' : 'error'
                      }`}
                    >
                      {notification?.message}
                    </div>
                  </div>
                )}
                <div className="w-layout-hflex flex-block-23">
                  <label form="name-6" className="form-input-label-2">
                    {t('Email')}
                  </label>
                </div>
                <div>{t('A confirmation link would be sent')}</div>
                <input
                  value={userEmail}
                  onChange={(e) => setUserEmail(e?.target?.value)}
                  className="form-input-2 secret-key-form-input w-input"
                  name="organisation-name-4"
                  data-name="Organisation Name 4"
                  placeholder=""
                  custom-value="Personal"
                  type="email"
                  id="organisation-name-4"
                />
              </div>
              <div
                onClick={!submitting ? handleSendInvite : () => {}}
                className="w-layout-hflex flex-block-24"
              >
                <a
                  data-w-id="a1034082-03aa-0166-ccd8-3d3e7afe116e"
                  href="#"
                  className="default-btn form-submit-btn invite-user-submit-btn w-button"
                >
                  {t('Submit')}{' '}
                  {submitting ? <IBLSpinLoader size={15} color={'#FFF'} /> : ''}
                </a>
              </div>
            </form>
            <div className="w-form-done">
              <div>{t('Thank you! Your submission has been received!')}</div>
            </div>
            <div className="w-form-fail">
              <div>
                {t('Oops! Something went wrong while submitting the form.')}
              </div>
            </div>
          </div>
        </div>
      </div>
      {invitedUsersModalFocused && (
        <InvitedUsers
          setFocused={() => {
            setInvitedUsersModalFocused(false);
          }}
        />
      )}
    </div>
  );
};

export default InviteUser;
